import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "svg2457",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 1045.9 473.7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".st0{fill:red}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("g", {
      id: "layer1",
      transform: "translate(254.92 753.316)"
    }, [
      _createElementVNode("g", {
        id: "g2511",
        transform: "translate(35.433 35.482)"
      }, [
        _createElementVNode("path", {
          id: "path3161",
          d: "M703.1-515c-22.8 6.1 5.3-45.6 5.3-45.6l38.6-80.6-82.3 4.4c-101.6.9-139.3 56-139.3 56-39.5 47.3-64.9 51.7-64.9 51.7-23.6 3.5-7.9-19.3-7.9-19.3l44.6-80.6c7.9-13.1-2.6-10.5-2.6-10.5l-45.5 8.8c-11.4 1.8-4.4-4.4-4.4-4.4l45.5-56.9c11.4-14.9-7.9-7-7.9-7l-84.1 24.5-21 35.9c-21 26.3 5.3 17.5 5.3 17.5-103.9 115.2-105.7 83.9-105.7 83.9-20.8-7.5 43.4-102 43.4-102l-73.5 12c-39.7 85-85.8 73.6-85.8 73.6-35.1-4.4 20.1-83.2 20.1-83.2l-64.9 8.8C74.7-586.5-7.3-546.6-7.3-546.6L48.3-641l-80.9 17.4-42.9 63.9c-21 31.6-34.2 49-34.2 49-7.9 6.1-42 35.9-42 35.9C-187.7-445-277.9-332-277.9-332c-18.4 24.5 35.9 3.5 35.9 3.5l64.8-17.5c24.5-6.1 42-24.5 42-24.5l95.4-119.1c18.4-5.3 120-64.8 120-64.8-28 85 32.4 79.7 32.4 79.7 43.8 0 95.4-31.5 95.4-31.5 5.3 40.3 38.6 30.7 38.6 30.7 65-2.8 167.4-139.4 167.4-139.4l12.3-1.7-34.2 56c-53.4 90.2 6.1 86.7 6.1 86.7 49.1-.9 112.1-44.7 112.1-44.7 3.5 49.9 43.8 43.8 43.8 43.8 39.4 0 85.8-34.2 85.8-34.2 2.6 32.4 35 33.3 35 33.3 34.2 0 55.2-46.4 55.2-46.4l-5.3-2.6c-11.2 8.8-21.7 9.7-21.7 9.7m-57-63.1c-12.3 23.7-44.7 39.4-44.7 39.4-58.7 11.4-19.3-35.9-19.3-35.9 15.8-15.8 37.7-23.6 37.7-23.6 50-14.1 26.3 20.1 26.3 20.1",
          class: "st0"
        }),
        _createElementVNode("path", {
          id: "path3171",
          d: "m38.3-770.8 61.3-12.3s14.9-5.2 4.4 12.3c0 0-22.8 55.2-65.7 62.2 0 0-41.2 11.4-30.7-19.3 0 0 14-36.8 30.7-42.9",
          class: "st0"
        })
      ])
    ], -1))
  ]))
}
export default { render: render }